module.exports = __webpack_public_path__ + "static/media/pdf_reader.4b8ae1b0.svg";